<div
  class="organization-list"
  [ngClass]="{
      'organization-list__largeDesktop': (responsiveService.isLargeDesktopScreen$ | async) === true,
      'organization-list__tablet': (responsiveService.isTabletScreen$ | async) === true,
      'organization-list__mobile': (responsiveService.isMobileScreen$ | async) === true
      }"
>
  @for (organization of displayedOrganizations; track organization.id) {
    <mat-card appearance="outlined" class="organization-card"
              [routerLink]="'/organization/' + (organization.slug || organization.id)">
      @if (organization.reach.name) {
        <mat-chip-set class="organization-reach-container" aria-label="Reach">
          <mat-chip class="organization-reach">
            <span class="font-weight--600">{{ organization.reach.name }}</span>
          </mat-chip>
        </mat-chip-set>
      }
      <img mat-card-image [src]="organization.headerImage.thumbnailUrl || '/nopicture.png'"
           [alt]="organization.headerImage.name"/>
      <mat-card-content>
        <div class="w-100 d-flex flex-row justify-content-between mt-3">
          <div class="organization-location d-flex flex-wraps align-items-start">
            <mat-icon fontSet="material-symbols-outlined" style="min-width: 16px;">
              location_on
            </mat-icon>&nbsp;
            <span style="word-break: break-word">{{ organization.location }}</span>
          </div>
        </div>
        <h3 class="text-dark my-2">
          {{ organization.name || '-' }}
        </h3>
        <span class="organization-description">
          {{ organization.shortDescription.length > 120 ? organization.shortDescription.slice(0, 120) + '…' : organization.shortDescription }}
        </span>
        <mat-chip-set class="organization-tag-container mt-2" aria-label="Goal and heritage type list">
          @for (goal of organization.goalList; track goal.id) {
            <mat-chip
              class="organization-goal"
              [style.color]="goalColor(goal).color"
              [style.background-color]="goalColor(goal).background"
              [style.border]="'1px solid ' + goalColor(goal).border"
            >
              <span class="font-weight--600">{{ goal.name || '-' }}</span>
            </mat-chip>
          }
          @for (heritageType of organization.heritageTypes; track heritageType.id) {
            <mat-chip class="organization-heritage">
              <span class="font-weight--600">{{ heritageType.name || '-' }}</span>
            </mat-chip>
          }
        </mat-chip-set>
      </mat-card-content>
    </mat-card>
  }

  <!-- Sentinel element for Intersection Observer -->
  @if (hasMoreOrganizations) {
    <div #sentinel style="height: 1px;"></div>
  }
</div>
